import React from 'react';
import './PoliticaPrivacidade.css';

const secoes = [
  { id: 'politica', titulo: 'Política de Privacidade', numero: '01' },
  { id: 'compromisso', titulo: 'Compromisso do Usuário', numero: '02' },
  { id: 'informacoes', titulo: 'Mais informações', numero: '03' },
];

export default function PoliticaPrivacidade() {
  return (
    <div className="lwPrivacyPage">

      <div id="conteudo">
        <section className="lwPrivacyHero" aria-labelledby="lwPrivacyTitle">
          <span className="lwPrivacyEyebrow">TRANSPARÊNCIA &amp; CONFIANÇA</span>
          <h1 id="lwPrivacyTitle">Política de <em>Privacidade</em></h1>
          <p>A sua privacidade é importante para nós.</p>
          <span className="lwPrivacyHeroDivider" aria-hidden="true" />
        </section>

        <div className="lwPrivacyLayout">
          <aside className="lwPrivacyAside" aria-label="Navegação da política">
            <div className="lwPrivacyAsideInner">
              <span className="lwPrivacyAsideLabel">NESTA PÁGINA</span>
              <nav>
                {secoes.map((s) => (
                  <a key={s.id} href={`#${s.id}`}>
                    <span className="lwPrivacyAsideNumber">{s.numero}</span>{s.titulo}
                  </a>
                ))}
              </nav>
              <div className="lwPrivacyHelp">
                <strong>Precisas de ajuda?</strong>
                <p>Estamos disponíveis para esclarecer qualquer dúvida.</p>
                <a href="mailto:lourdyane.rod@gmail.com">Entrar em contacto <span aria-hidden="true">↗</span></a>
              </div>
            </div>
          </aside>

          <article className="lwPrivacyArticle">
            <section id="politica" className="lwPrivacySection" aria-labelledby="lwSection01">
              <span className="lwPrivacySectionNumber">01 / PRIVACIDADE</span>
              <h2 id="lwSection01">Política de Privacidade</h2>
              <p>A sua privacidade é importante para nós. É política do Lou's Way respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site Lou's Way, e outros sites que possuímos e operamos.</p>
              <p>Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e consentimento. Também informamos por que estamos coletando e como será usado.</p>
              <p>Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não autorizados.</p>
              <p>Não compartilhamos informações de identificação pessoal publicamente ou com terceiros, exceto quando exigido por lei.</p>
              <p>O nosso site pode ter links para sites externos que não são operados por nós. Esteja ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos aceitar responsabilidade por suas respectivas políticas de privacidade.</p>
              <p>Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que talvez não possamos fornecer alguns dos serviços desejados.</p>
              <p>O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com dados do usuário e informações pessoais, entre em contacto connosco.</p>
            </section>

            <section id="compromisso" className="lwPrivacySection" aria-labelledby="lwSection02">
              <span className="lwPrivacySectionNumber">02 / UTILIZAÇÃO RESPONSÁVEL</span>
              <h2 id="lwSection02">Compromisso do Usuário</h2>
              <p>O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o Lou's Way oferece no site e com caráter enunciativo, mas não limitativo:</p>
              <div className="lwPrivacyRules">
                <div className="lwPrivacyRule"><span>A</span><p>Não se envolver em atividades que sejam ilegais ou contrárias à boa fé a à ordem pública;</p></div>
                <div className="lwPrivacyRule"><span>B</span><p>Não difundir propaganda ou conteúdo de natureza racista, xenofóbica, jogos de sorte ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os direitos humanos;</p></div>
                <div className="lwPrivacyRule"><span>C</span><p>Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do Lou's Way, de seus fornecedores ou terceiros, para introduzir ou disseminar vírus informáticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de causar danos anteriormente mencionados.</p></div>
              </div>
            </section>

            <section id="informacoes" className="lwPrivacySection" aria-labelledby="lwSection03">
              <span className="lwPrivacySectionNumber">03 / INFORMAÇÕES ADICIONAIS</span>
              <h2 id="lwSection03">Mais informações</h2>
              <p>Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados, caso interaja com um dos recursos que você usa em nosso site.</p>
              <div className="lwPrivacyEffective"><span aria-hidden="true">✧</span><p>Esta política é efetiva a partir de <strong>13 October 2026 14:17</strong></p></div>
            </section>
          </article>
        </div>
      </div>

    </div>
  );
}
    